import { EventDataEvents } from "../Consts";
import { EulerStateManager } from "../EulerStateManager";
import { EventData } from "../EventData";
import { BaseState } from "../States/BaseState";

import { EventFetcher } from "../../utils/EventFetcher";
import { Gamesocket } from "../../utils/Gamesocket";
import { validateData } from "../../utils/validators";
import { ValidatedData } from "../../utils/validators";

import config from "../../../game.config.json";

class GetCurrentEvent extends BaseState<EulerStateManager> {
  public id = "GetCurrentEvent";
  constructor(stateManager: EulerStateManager) {
    super(stateManager); // Pass the StateManager to the base class
  }

  private async initData(
    validator: (data: any, sportType: string) => ValidatedData,
  ) {
    const fetchCurrentEvent = new EventFetcher({
      channelID: config.channel,
      url: config.URL,
    });
    const currentEvent = await fetchCurrentEvent.fetchEvent("current");
    if (!currentEvent) {
      console.log("Failed to fetch current event");

      return;
    }
    Gamesocket.getInstance(config.URL, currentEvent.id, {
      onMessage(data) {
        const validData = validator(data, config.sportType);
        const eventData = EventData.getInstance();
        if (!validData.isValid) {
          console.warn(`Invalid ${config.sportType} data from socket: `, data);
          return;
        }
        console.debug("DATA HERE: ", validData.data);
        if (!validData.data) return;
        eventData.parseDataBasedOnState(validData.data);

        // dataParser(validData.data);
      },
    });
  }

  public onEnter(stateManager: EulerStateManager): void {
    console.log("ENTERED GET CURRENT EVENT STATE");
    this.stateManager = stateManager; // Set the StateManager reference
    super.onEnter(stateManager); // Call the super method
    this.stateManager.onEnterGetCurrentEventState();

    this.bindEvents();
    this.subscribeToEvents();

    this.initData(validateData);
  }

  private bindEvents() {
    this.transition = this.transition.bind(this);
  }

  private subscribeToEvents() {
    const eventData = EventData.getInstance();
    eventData.subscribeToEvent(
      EventDataEvents.ON_DATA_ASSIGNED,
      this.transition,
    );
  }

  public transition(): void {
    console.log(
      "TRANSITIONING TO UPDATE PLAYING STATE FROM GET CURRENT EVENT STATE",
    );
    this.stateManager?.changeState(this.stateManager.eulerUpdatePlayingState);
  }

  public onExit(): void {
    super.onExit();
  }
}

export { GetCurrentEvent };
